import { render, staticRenderFns } from "./userUnbundlingCardList.vue?vue&type=template&id=52643792&scoped=true"
import script from "./userUnbundlingCardList.vue?vue&type=script&lang=js"
export * from "./userUnbundlingCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52643792",
  null
  
)

export default component.exports